var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { FormItemTypes } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { UploadMultipleAttachmentAPICall } from "../../services/apiCalls";
import AttachmentList from "../AttachmentList";
export var Attachment = [{
        type: FormItemTypes.Attachment,
        name: "Attachments",
        value: [],
        inputProps: {
            accept: [".xlsx", ".csv", ".pdf", ".docx", ".mp4", ".jpg", ".jpeg", ".png"]
        },
        columnSize: 0,
        setFieldProps: function (formValues, currValue) {
            var _formValues$FileAttac;
            var activeFiles = ((_formValues$FileAttac = formValues.FileAttachments) === null || _formValues$FileAttac === void 0 ? void 0 : _formValues$FileAttac.filter(function (file) {
                return file.IsDeleted === 0 || file.IsDeleted === undefined || file.IsDeleted === null;
            })) || [];
            return {
                type: FormItemTypes.Attachment,
                disabled: activeFiles.length >= 4
            };
        },
        setFormState: function (formValues, currValue, field) {
            var maxSizeInBytes = 5 * 1024 * 1024;
            var filteredFiles = currValue === null || currValue === void 0 ? void 0 : currValue.filter(function (item) {
                var size = item instanceof File ? item.size : item === null || item === void 0 ? void 0 : item.Size;
                return size <= maxSizeInBytes;
            });
            var updatedValue = filteredFiles === null || filteredFiles === void 0 ? void 0 : filteredFiles.map(function (item) {
                var _item$size;
                return item instanceof File ? {
                    FileName: item.name,
                    Size: (_item$size = item.size) !== null && _item$size !== void 0 ? _item$size : 0,
                    Type: item.type,
                    IsChecksheetFilled: 0,
                    id: item
                } : item;
            });
            return {
                FileAttachments: updatedValue
            };
        },
        validator: function (value, state) {
            var maxSize = 5 * 1024 * 1024;
            if (!value || value.length === 0)
                return "";
            var latestFile = value[value.length - 1];
            var size = latestFile instanceof File ? latestFile.size : latestFile === null || latestFile === void 0 ? void 0 : latestFile.Size;
            if (size > maxSize) {
                return "The latest uploaded file exceeds the 5MB limit.";
            }
            return "";
        },
        uploadAttachmentAPI: UploadMultipleAttachmentAPICall,
        uploadButtonProps: {
            variant: "text",
            color: "primary"
        },
        attachmentButtonProps: {
            sx: {
                display: "none"
            }
        }
    }, {
        type: FormItemTypes.Custom,
        name: "FileAttachments",
        element: AttachmentList,
        columnSize: 12,
        setFormState: function (formValues, currValue, field) {
            var updatedAttachments = __spreadArray([], formValues.Attachments, true);
            var deletedFiles = currValue.filter(function (item) { return item.IsDeleted === 1; });
            deletedFiles.forEach(function (deletedFile) {
                var index = updatedAttachments.findIndex(function (attachment) {
                    return (attachment.name || attachment.FileName) === deletedFile.FileName;
                });
                if (index !== -1) {
                    var attachment = updatedAttachments[index];
                    var isFileInstance = attachment.name && attachment.lastModified !== undefined;
                    if (isFileInstance) {
                        updatedAttachments.splice(index, 1);
                    }
                    else {
                        updatedAttachments[index] = _objectSpread(_objectSpread({}, attachment), {}, {
                            IsDeleted: 1
                        });
                    }
                }
            });
            return {
                Attachments: updatedAttachments
            };
        },
        validator: function (value, state) {
            var maxSize = 5 * 1024 * 1024;
            var invalidFiles = value === null || value === void 0 ? void 0 : value.filter(function (file) {
                var _file$size;
                return ((_file$size = file === null || file === void 0 ? void 0 : file.size) !== null && _file$size !== void 0 ? _file$size : file === null || file === void 0 ? void 0 : file.Size) > maxSize;
            });
            if ((invalidFiles === null || invalidFiles === void 0 ? void 0 : invalidFiles.length) > 0) {
                return "Some files exceed the 5MB limit.";
            }
            return "";
        }
    }];
